import { Dispatch, SetStateAction } from 'react';
import {
    Modal,
    TextField,
    Button,
    MenuItem,
    Select,
    SelectChangeEvent
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import { Category } from '@mui/icons-material';

interface Props {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>
}

export default function AddPrompt({ open, onClose, setOpen }: Props) {
        const [Category, setCategory] = React.useState('default');
    
    const handleCategoryChange = (event: SelectChangeEvent) => {
        setCategory(event.target.value as string);
    };

    return (
        <Modal
            className="modal alertConfig_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog">
                <div className="modal-body">
                    <div className="modal_title">
                        <h2>Add Prompt</h2>
                        <div className="btn-close" onClick={() => setOpen(false)}>
                            <CloseIcon />
                        </div>
                    </div>

                    <form className="form" action="">
                       
                        <div className="control_group">
                            <label> Prompt</label>
                            <TextField
                                fullWidth
                                hiddenLabel
                                placeholder="Enter Label"
                            />
                        </div>
                         <div className="control_group">
                            <label>Select Language</label>
                            <Select
                                fullWidth
                                value={Category}
                                onChange={handleCategoryChange}
                            >
                                <MenuItem disabled value="default">Select </MenuItem>
                                <MenuItem value="Low">English</MenuItem>
                                <MenuItem value="Medium">French</MenuItem>
                                <MenuItem value="High">Spanish</MenuItem>
                            </Select>
                        </div>
                        <div className="footer_btn_flex">
                            <Button className="btn btn_grey" onClick={() => setOpen(false)}>Cancel</Button>
                            <Button className="btn btn_primary" onClick={() => setOpen(false)}>Submit</Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
}
